<vectronic-card [title]="'Edit Device'" [displayClose]="true" (closed)="dialogRef.close()">
  <ng-container body [formGroup]="editDeviceForm">
    <mat-dialog-content class="dialog-body">
      <mat-form-field appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput [formControlName]="'deviceName'" [readonly]="isReader()" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="textarea personal-note">
        <mat-label>Personal Notes</mat-label>
        <textarea matInput [formControlName]="'deviceLabel'"></textarea>
        <mat-hint>Only visible to you</mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline" class="textarea">
        <mat-label>Description</mat-label>
        <textarea matInput [formControlName]="'description'"></textarea>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions class="modal-button-container">
      <button mat-button color="warn" type="submit" class="button__reset-button" (click)="reset()">
        <mat-icon>cancel</mat-icon>
        Reset
      </button>
      <button
        mat-button
        color="accent"
        type="submit"
        class="button__apply-button"
        (click)="apply()"
      >
        <mat-icon>check_circle</mat-icon>
        Apply
      </button>
    </mat-dialog-actions>
  </ng-container>
</vectronic-card>
